import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  forgetLogin,
  resetPassword,
  userurl1,
} from "../helperFunctions/apiFunction";
import toast from "react-hot-toast";
import ForgetLogin from "./ForgetLogin";
import lootie from "../assets/images/login-animate1.json";
import Lottie from "react-lottie";
import { Typography, Button, Select, Option } from "@material-tailwind/react";

function Signup() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: lootie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const { basicToken } = useSelector((state) => state.clientData);

  const [loggedIn, setLoggedIn] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const [loading, setLoading] = useState(false);
  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");
  const [refreshToken, setRefreshToken] = useState();
  const [loginData, setLoginData] = useState();
  const [userData, setUserData] = useState();

  const handleLogin = (event) => {
    setLoading(true);
    const obj = { email: Email, password: Password };

    forgetLogin(obj, basicToken)
      .then((res) => {
        if (res.code === 401) {
          toast.error(res.message);
        }
        if (res.code === 200) {
          toast.success("Login Success");
          setLoginData(res.data.user);
          setRefreshToken(res.data.tokens.refresh.token);
          setLoggedIn(true);
        }
      })
      .catch((e) => {
        toast.error("Something went wrong!");
      })
      .finally(() => {
        setLoading(false);
      });

    event.preventDefault();
  };

  const fetchUsersById = async () => {
    try {
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${refreshToken}`);

      const requestOptions = {
        method: "GET",
        headers: headers,
        redirect: "follow",
      };

      const response = await fetch(
        `${userurl1}collection/usersByClient/userdata/${loginData?.clientId}`,
        requestOptions
      );

      if (!response.ok) {
        // If the response status is not OK (e.g., 404 Not Found), throw an error
        throw new Error(
          `Failed to fetch user data. Status: ${response.status}`
        );
      }

      const userData = await response.json();
      setUserData(userData);

      // Do something with the fetched user data
    } catch (error) {
      // Handle errors here
      toast.error("Error fetching user data");
    }
  };

  const handleUserChange = (value) => {
    setSelectedUser(value);
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await resetPassword(refreshToken, selectedUser);
      if (response?.code === 200 || response?.code === 201) {
        toast.success("Please check your email to Reset Password", {
          className: "text-[12px]",
        });
      } else if (response.code === 400) {
        toast.error(response?.message, {
          className: "text-[12px]",
        });
      } else {
        toast.error(response?.message, {
          className: "text-[12px]",
        });
      }
    } catch (error) {
      toast.error("Something went wrong!", {
        className: "text-[12px]",
      });
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
      setSelectedUser("");
    }
  };

  useEffect(() => {
    fetchUsersById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginData]);

  return (
    <>
      {loggedIn ? (
        <div className="flex h-screen">
          {/* Left Pane */}
          <div className="hidden lg:flex items-center justify-center flex-1 bg-white text-black">
            <div className="max-w-md text-center">
              <Lottie options={defaultOptions} />
            </div>
          </div>
          {/* Right Pane */}
          <div className="w-full bg-gray-100 lg:w-1/2 flex items-center justify-center">
            <div className="max-w-md w-full p-6">
              <Typography
                variant="h2"
                color="blue-gray"
                className="text-center mb-12"
              >
                Welcome to{" "}
                <span className="text-transparent bg-gradient-to-r from-indigo-400 to-cyan-400 bg-clip-text relative">
                  TrustSpike
                </span>
              </Typography>
              <Typography
                variant="h6"
                className="!text-blue-gray-200 text-sm text-center mb-7 p-3"
              >
                Select a user from the dropdown and click Reset Password
              </Typography>
              <form className="space-y-4" onSubmit={handleResetPassword}>
                <div>
                  <Typography className="mb-2" variant="h6">
                    Select User
                  </Typography>
                  <Select
                    label="Role Search"
                    name="rolesearch"
                    value={selectedUser}
                    onChange={(value) => handleUserChange(value)}
                  >
                    <Option value="">Select Role</Option>
                    {userData?.map((item, index) => (
                      <Option value={item.userName} key={index}>
                        {item.userName}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div>
                  <Button
                    type="submit"
                    size="lg"
                    className={`w-full text-center mt-2 ${
                      loading ? "flex justify-center items-center" : ""
                    }`}
                    loading={loading}
                  >
                    Reset Password
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <ForgetLogin
          handleLogin={handleLogin}
          Email={Email}
          setEmail={setEmail}
          Password={Password}
          setPassword={setPassword}
          loading={loading}
        />
      )}
    </>
  );
}

export default Signup;
